import { ToggleButtonGroup } from '@dora/components';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Typography from '@mui/material/Typography';
import * as NEA from 'fp-ts/NonEmptyArray';
import * as Preact from 'preact';
import * as ConfigurationCard from './configurationCard';
import { SofaSeat } from './sofa';

export interface Props {
    value: number;
    buttonSize: 'small' | 'medium';
    onSeatCountChange: (newSeats: number) => void;

    seatCountButtonDisabled: boolean;

    enableInterstitials: boolean | 'advanced';

    seat: SofaSeat;
    interstitialCount: number;
    maxInterstitials: number;

    interstitialName?: string;

    onInterstitialSelectionChange: (interstitials: number) => void;
}

export const Component = (p: Props) => {
    const interstitialDisabled: boolean = p.maxInterstitials === 0;
    const { seat } = p;

    return (
        <>
            <ConfigurationCard.Component>
                <Typography variant="h5">{seat.displayName}</Typography>
                <ToggleButtonGroup.Component
                    aria-label={seat.displayName}
                    value={p.value}
                    size={p.buttonSize}
                    handleChange={p.onSeatCountChange}
                    options={NEA.range(seat.minimum, seat.maximum)}
                    disabled={p.seatCountButtonDisabled}
                />
                {p.enableInterstitials === true && p.interstitialName && (
                    <FormControlLabel
                        sx={{ pl: '12px' }}
                        disabled={interstitialDisabled}
                        control={
                            <Checkbox
                                checked={p.interstitialCount > 0}
                                onChange={e => {
                                    p.onInterstitialSelectionChange(e.target.checked ? 1 : 0);
                                }}
                            />
                        }
                        label={`Add ${p.interstitialName}`}
                    />
                )}
            </ConfigurationCard.Component>
            {p.enableInterstitials === 'advanced' && p.interstitialName && (
                <ConfigurationCard.Component>
                    <Typography variant="body1">{p.interstitialName}</Typography>
                    <ToggleButtonGroup.Component
                        aria-label={seat.displayName}
                        value={p.interstitialCount}
                        size={p.buttonSize}
                        handleChange={v => {
                            p.onInterstitialSelectionChange(v);
                        }}
                        options={NEA.range(0, 3)}
                        disabled={interstitialDisabled}
                        disableOption={count => count > p.maxInterstitials}
                        sx={{ height: '36px' }}
                    />
                </ConfigurationCard.Component>
            )}
        </>
    );
};
